interface ServiceImageProps {
  image: string;
  title: string;
}

export default function ServiceImage({ image, title }: ServiceImageProps) {
  return (
    <div className="relative bg-white rounded-lg overflow-hidden shadow-sm">
      <div className="w-full h-[600px] flex items-center justify-center">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
}